import classNames from 'classnames/bind';
import React from 'react';

import styles from './Row.module.scss';

const cx = classNames.bind(styles);

const Row = ({ label, value, unit, valueStyle = {} }) => {
  return (
    <div className={cx('container')}>
      <div className={cx('label')}>{label}</div>
      <div className={cx('value')} style={valueStyle ? valueStyle : {}}>
        {value}
        {unit && <span className={cx('unit')}>{unit}</span>}
      </div>
    </div>
  );
};

export default Row;
